/**
 * Polyfill for btoa to handle non-Latin1 characters (e.g. emoji, unicode).
 * The native btoa() throws InvalidCharacterError for characters outside Latin1 range.
 * This must be loaded as the very first import to ensure it patches btoa before
 * any other code runs.
 */
const _originalBtoa = window.btoa;
window.btoa = function safeBtoa (str) {
    try {
        return _originalBtoa.call(window, str);
    } catch (e) {
        if (e instanceof DOMException) {
            // Fallback: encode via TextEncoder for strings with non-Latin1 chars
            const bytes = new TextEncoder().encode(str);
            let binary = '';
            for (let i = 0; i < bytes.length; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return _originalBtoa.call(window, binary);
        }
        throw e;
    }
};
